import {GET_CROSS_FILTER_DATA} from '@/store/getterTypes';

export default {
  [GET_CROSS_FILTER_DATA](state) {
    return state.crossFilterData;
  },
};
